import type { AxiosResponse } from 'axios'

export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

export function filenameFromDisposition(disposition: string | undefined, fallback: string): string {
  const match = disposition?.match(/filename="?([^"]+)"?/)
  return match?.[1] ?? fallback
}

export function saveAxiosBlobResponse(res: AxiosResponse<Blob>, fallbackFilename: string): void {
  const contentType = (res.headers['content-type'] as string | undefined) ?? 'application/octet-stream'
  const blob = res.data instanceof Blob ? res.data : new Blob([res.data], { type: contentType })
  const filename = filenameFromDisposition(
    res.headers['content-disposition'] as string | undefined,
    fallbackFilename,
  )
  triggerBlobDownload(blob, filename)
}

/** When API returns JSON errors with responseType blob, parse for toast display. */
export async function enrichBlobAxiosError(error: unknown): Promise<unknown> {
  const err = error as { response?: { data?: Blob; status?: number } }
  const data = err.response?.data
  if (!(data instanceof Blob)) {
    return error
  }

  try {
    const text = await data.text()
    const json = JSON.parse(text) as { message?: string; errors?: Record<string, string[]> }
    return {
      ...err,
      response: {
        ...err.response,
        data: json,
      },
    }
  } catch {
    return error
  }
}
